import { cn } from '@/lib/utils';
import { useTranslation } from '@hooks/useTranslation';

export function MenuItemNotes({
  internalNotes = [],
  externalNotes = [],
  className,
}: {
  internalNotes?: string[];
  externalNotes?: string[];
  className?: string;
}) {
  const { t } = useTranslation();

  if (internalNotes.length === 0 && externalNotes.length === 0) return null;

  return (
    <div
      className={cn(
        'grid grid-cols-[max-content_minmax(0,1fr)] gap-x-3 gap-y-1 text-xs text-grey',
        className,
      )}
    >
      {internalNotes.length > 0 && (
        <NoteGroup label={t('events_section.menu_item_notes.internal')} notes={internalNotes} />
      )}
      {externalNotes.length > 0 && (
        <NoteGroup label={t('events_section.menu_item_notes.external')} notes={externalNotes} />
      )}
    </div>
  );
}

function NoteGroup({ label, notes }: { label: string; notes: string[] }) {
  return (
    <div className="contents">
      <span className="font-semibold">{label}</span>
      <div className="min-w-0 whitespace-pre-line break-words">
        {notes.map((note, index) => (
          <div key={index}>{note}</div>
        ))}
      </div>
    </div>
  );
}

export function toNoteLines(...notes: Array<string | null | undefined>): string[] {
  return notes.map((note) => note?.trim()).filter((note): note is string => Boolean(note));
}
